import type { FaireProductEntity } from "../../entity_types/product";

export const p_4dj2cqw8gg: FaireProductEntity = {
  token: "p_4dj2cqw8gg",
  type: "product",
  name: "Elephant - Organic Baby Lovey Security Blanket Cuddle Cloth",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/3d5266bb1551e522796cb0dce8cde4ec3f89c9c0f73665b1db5275b5b8477b8f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/186173eaf446541e762b9d033dc27786fd0e8e55e7c5da56440c0f2337db4d91.png",
    "https://cdn.faire.com/fastly/29e124fe3adfafb42684d1184d9046f2419477c92e198b6a5e155fd0fa0d96ee.png",
    "https://cdn.faire.com/fastly/acd6ef92a723630e2cf0ae3be46f837b2ef869696c2750a9f1dd0a6edaabe093.jpeg",
    "https://cdn.faire.com/fastly/7d2163f9c28093aa4654b1b7fdd8bf03f73ba020b85eaa72f218876e052e2fd6.jpeg",
    "https://cdn.faire.com/fastly/127b9b69b35a86f16368e973065d4333fe39142f9070991719a134ac7311d827.jpeg",
    "https://cdn.faire.com/fastly/2c3d9da090e68fb777be7c960868c1c2cb41c560afe297aef827303fcbdb1c9e.jpeg",
    "https://cdn.faire.com/fastly/803fcd2440899a6a9e20ad772be80dd822ade113caa5178002a66280ebe873b2.jpeg",
    "https://cdn.faire.com/fastly/d7c2175b3d624c5332165a65b78e18de551f36c7457bcdc8c8dd465feb20730b.jpeg",
    "https://cdn.faire.com/fastly/972b438afb8380bb8aee549131726d7a9670c21c5db95464857af0da7cccb0ca.jpeg",
    "https://cdn.faire.com/fastly/ebfb2d8a441125e06bb3d2ddaec551037d4ba076c5f81560db021db2e4538a33.jpeg",
    "https://cdn.faire.com/fastly/01ac8ae24faf505ae7cfd8cc1438e7f3e96088f70e5ad5fb660a69eb301dfb59.jpeg",
    "https://cdn.faire.com/fastly/443a1c942a8b9ff4e3acec6f0fb749773958f8849c82f0a58e9a2187a9b37159.jpeg",
  ],
  priceDollars: 15,
  description:
    "Luxurious 100% organic cotton soft sweater knit lovey security blanket toy for babies - 14x14\" approx.\n\n• Ultra-Soft, lightweight, all-season, breathable, cozy and comfy.\n• Non-toxic & natural fabrication for sensitive skin, eco-friendly & sustainable materials used.\n• Made from sustainably grown organic cotton, supporting better livelihoods of small grower farmers.\n• Conscientiously designed in USA & ethically made by artisans at a GOTS certified facility in India.\n• Experience 'pure comfort' by Viverano, a family-owned small business.\n\n𝐖𝐚𝐬𝐡𝐢𝐧𝐠 𝐢𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\nMachine wash cold. Tumble dry.\n\n𝐕𝐈𝐕𝐄𝐑𝐀𝐍𝐎 𝐎𝐫𝐠𝐚𝐧𝐢𝐜 𝐓𝐨𝐲𝐬:\n• Quirky & cuddly collection of organic cotton fine knit toys for your precious little ones.\n• Fresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\n• Lovingly made by hand using certified organic cotton, safe for hugging & snuggling.\n• Great for buddy adventures, good company and bedtime snuggles.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:03:40.879Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
